export default "__VITE_ASSET__3be6c88d__"